// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_R9t","cls2":"LettersModal-cls2_7zA LettersModal-cls1_R9t"};